import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { HDate } from '@hebcal/core';
import LanguageToggle from './LanguageToggle';
import { useAuth } from '../../hooks/useAuth';
import { getTodayString } from '../../utils/dateShortcuts';
import { dateStringToNoonUtc } from '../../utils/israelTime';

export default function Footer() {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const { user, signOut } = useAuth();
  const isHebrew = i18n.language === 'he';
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia('(max-width: 639px)').matches : false
  );

  useEffect(() => {
    const mq = window.matchMedia('(max-width: 639px)');
    const update = () => setIsMobile(mq.matches);
    update();
    mq.addEventListener('change', update);
    return () => mq.removeEventListener('change', update);
  }, []);

  const onMobileMapView =
    isMobile &&
    location.pathname === '/shuls' &&
    new URLSearchParams(location.search).get('view') === 'map';

  if (onMobileMapView) return null;

  const handleLogout = async () => {
    await signOut();
    navigate('/');
  };

  const authControls = (
    <>
      {user ? (
        <>
          <span className="text-xs text-ash truncate max-w-[10rem] sm:max-w-xs">
            {user.email}
          </span>
          <button
            type="button"
            onClick={handleLogout}
            className="text-xs text-ink hover:opacity-70 transition-opacity"
          >
            {t('admin.logout')}
          </button>
        </>
      ) : (
        <Link
          to="/login"
          className="text-xs text-ink hover:opacity-70 transition-opacity"
        >
          {t('admin.login')}
        </Link>
      )}
    </>
  );

  const hebrewDate = new HDate(dateStringToNoonUtc(getTodayString())).toString();

  return (
    <footer className="bg-fog border-t border-ink/10 mt-auto">
      <div className="max-w-5xl mx-auto px-4 py-4 text-center text-sm text-ash">
        <p>{hebrewDate}</p>
        <p className="mt-1">
          {isHebrew ? 'רמת בית שמש' : 'Ramat Bet Shemesh'}
        </p>
        <div className="mt-3 pt-3 border-t border-ink/10 flex items-center justify-center gap-3 flex-wrap text-xs text-ash">
          <LanguageToggle />
          <Link to="/contact" className="text-xs text-ink hover:opacity-70 transition-opacity">
            {t('nav.contact')}
          </Link>
          <Link to="/privacy" className="text-xs text-ink hover:opacity-70 transition-opacity">
            {t('privacy.title')}
          </Link>
          <Link to="/terms" className="text-xs text-ink hover:opacity-70 transition-opacity">
            {t('terms.title')}
          </Link>
          <Link to="/accessibility" className="text-xs text-ink hover:opacity-70 transition-opacity">
            {t('accessibility.title')}
          </Link>
          {authControls}
        </div>
      </div>
    </footer>
  );
}
